const DATE_REGEX = /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
const ID_NUMBER_REGEX = /^\d{9}$/;

export const validateDate = (value) => DATE_REGEX.test(value);

export const validateDateNotInFuture = (value) => {
  if (!DATE_REGEX.test(value)) return false;
  const [day, month, year] = value.split('/').map(Number);
  const date = new Date(year, month - 1, day);
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  return date <= today;
};

export const validateIdNumber = (value) => ID_NUMBER_REGEX.test(value);

export const formatDateInput = (rawValue) => {
  let value = rawValue.replace(/[^\d/]/g, '');
  if (value.length === 2 && !value.includes('/')) {
    value += '/';
  } else if (value.length === 5 && value.split('/').length === 2) {
    value += '/';
  }
  return value.length <= 10 ? value : value.slice(0, 10);
};
